import { mapGetters, mapMutations } from 'vuex'
export default {
  methods: {
    ...mapMutations("popup", ["SET_HIDE_POPUP"]),

    hidePopup(id) {
      // console.log(id);
      this.SET_HIDE_POPUP(id)
    }
  },

  computed: {
    ...mapGetters("popup", ["getActivePopup"])
  }
}